import * as React from 'react';
import SingleRecipientType from 'owa-service/lib/contract/SingleRecipientType';
import strings from 'owa-strings/owa-mini-strings';
import { enterKeyHandler } from 'window-utils/lib/keyHandlerUtils';
import { format } from 'owa-strings';
import { getNameAndEmailForSender } from 'mini-mail-common/lib/utils/getNameAndEmailForSender';
import { MultiSelectCheckbox, MultiSelectCheckboxProps } from './MultiSelectCheckbox';
import { PersonaControl } from 'owa-persona';
import { PersonaSize } from 'fabric-persona/lib/components/Persona.Props';

const styles = require('./MailListItem.scss');
const classNames = require('classnames/bind').bind(styles);

export interface PersonaCheckboxProps extends MultiSelectCheckboxProps {
    isInCheckedMode: boolean;
    lastSender: SingleRecipientType;
    rowId: string;
    onMultiSelect: (rowId: string) => void;
    isAvatarEnabled: boolean;
}

const PersonaCheckbox = (props: PersonaCheckboxProps) => {
    const { rowId, isInCheckedMode, lastSender, onMultiSelect, isAvatarEnabled } = props;

    const onClickPersona = React.useCallback(() => {
        onMultiSelect(rowId);
    }, [rowId]);

    const onClickPersonaCheckbox = event => {
        event.stopPropagation();
        onClickPersona();
    };

    let personaComponent: JSX.Element = null;
    let checkboxComponent: JSX.Element = null;

    const checkboxContainerClassNames = classNames(
        {
            'personaCheckbox--show': isInCheckedMode,
        },
        styles.personaCheckbox
    );

    checkboxComponent = (
        <div
            className={checkboxContainerClassNames}
            data-node-name="persona-checkbox"
            onKeyDown={enterKeyHandler(onClickPersonaCheckbox)}
            onClick={onClickPersonaCheckbox}>
            <MultiSelectCheckbox isSelected={props.isSelected} />
        </div>
    );

    const lastSenderMailbox = lastSender?.Mailbox;
    const displaySelfPersona = !(lastSenderMailbox?.Name || lastSenderMailbox?.EmailAddress);
    const { name, emailAddress } = getNameAndEmailForSender(lastSender, displaySelfPersona);

    const isAvatarToBeShown = isAvatarEnabled && !isInCheckedMode;

    personaComponent = (
        <div data-node-name="persona-control">
            <PersonaControl
                tabIndex={-1}
                className={styles['mailListItem--persona']}
                name={name}
                onClickPersona={onClickPersona}
                emailAddress={emailAddress}
                size={PersonaSize.small}
                ariaLabel={format(strings.messageHeaderContactCardAriaLabel, name)}
            />
        </div>
    );

    return (
        <div className={styles['mailListItem--leftContainer']} aria-hidden>
            {isAvatarToBeShown && personaComponent}
            {checkboxComponent}
        </div>
    );
};

export default PersonaCheckbox;
